import React from "react";
import PropTypes from "prop-types";
import { FormFeedback, Button, Input } from "reactstrap";
import ReactDatePicker from "react-datepicker"; // https://hacker0x01.github.io/react-datepicker/
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import "./date-picker-overwrite.css";

// This component wraps 'react-datepicker' and is responsible for displaying a
// warning if the user selects a due date that's less than week from the current
// date

class DatePicker extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // Cloning what got passed in, because moment()s are mutable
      defaultDueDate: props.value && props.value.clone(), // Only clone if we get passed a moment() object. Otherwise, this is undefined
      minDueDate: moment().add(1, "days")
    };

    this.clearDate = this.clearDate.bind(this);
    this.isTooSoon = this.isTooSoon.bind(this);
  }

  clearDate(event) {
    event.preventDefault();
    this.props.onChange(this.state.defaultDueDate);
  }

  isTooSoon(momentDate) {
    if (!momentDate) {
      return false;
    }
    const { daysNoticeNeeded } = this.props;
    const today = moment();
    const clonedMoment = momentDate.clone();
    const isLessThanWeek = clonedMoment
      .subtract(daysNoticeNeeded, "days")
      .isBefore(today);

    return isLessThanWeek;
  }

  render() {
    const { minDueDate } = this.state;
    const { value, onChange, warningText } = this.props;
    const displayWarning = this.isTooSoon(value);

    return (
      <div
        className={`row row justify-content-between col ${
          displayWarning ? "has-danger" : ""
        }`}
        style={{ minWidth: "200px" }}
      >
        <div className="col-md-9 mb-2">
          <ReactDatePicker
            customInput={<CustomInput style={{ backgroundColor: "#fff" }} />}
            popoverAttachment="bottom center"
            popoverTargetAttachment="top center"
            selected={value}
            minDate={minDueDate}
            onChange={onChange}
            showTimeSelect={true}
            timeIntervals={15}
            dateFormat={"lll"}
          />
        </div>
        <div className="col-md-3">
          <Button size="sm" color="secondary" onClick={this.clearDate}>
            Reset Due Date
          </Button>
        </div>
        {displayWarning ? (
          <FormFeedback style={{ display: "inline" }} className="col-12">
            {warningText}
          </FormFeedback>
        ) : null}
      </div>
    );
  }
}

DatePicker.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.instanceOf(moment),
  daysNoticeNeeded: PropTypes.number,
  warningText: PropTypes.string
};

DatePicker.defaultProps = {
  daysNoticeNeeded: 6,
  warningText: "We recommend choosing a due date more than 7 days from today."
};

export default DatePicker;

// NOTE: This is defined as a class because we're passing it to Datepicker,
// which needs to give it a ref
class CustomInput extends React.Component {
  render() {
    const { value, style, onClick } = this.props;
    // value is a moment object, and we can pass it directly to the custom input element here
    return (
      <Input
        style={style}
        value={value || "Click here to set date"}
        onClick={onClick}
        readOnly
      />
    );
  }
}

CustomInput.propTypes = {
  style: PropTypes.object,
  value: PropTypes.string, // react-datepicker passes this in for us
  onClick: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/Shared/Forms/DatePicker.js